import type { SynchronizedWith } from '@openx/types/deal';
import type { DealDetailsSectionProps } from '../../types';
import { TddSyncErrorsSection } from './sections/TddSyncErrorsSection';
import { TddSyncStatusesSection } from './sections/TddSyncStatusesSection';

export type DealTDD = {
  synchronized_with: Required<Pick<SynchronizedWith, 'pdp_sync'>>;
};

export const DealTddSyncTab = <T extends DealTDD = DealTDD>({ deal }: DealDetailsSectionProps<T>) => {
  return (
    <>
      <TddSyncStatusesSection pdpSync={deal.synchronized_with.pdp_sync} />
      <TddSyncErrorsSection
        pdpLastSyncError={deal.synchronized_with.pdp_sync.pdp_last_sync_error}
        syncStatus={deal.synchronized_with.pdp_sync.pdp_sync_status}
      />
    </>
  );
};
